DeviceManager.Internal.ExternalDisplay = {};
//# sourceMappingURL=external-display.js.map
